import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { WorkAPI } from "../../../axios/api";
import { useAbortedEffect, useSearch, usePop } from "../../../components/hooks";
import { AxiosMulti, formatApiResult } from "../../../axios/request/common";
import moment from "moment";
import axios from "axios";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import MemberRecordHeartbeat from "../record/heartbeat";
import MemberRecordWeight from "../record/weight";
import MemberRecordSugar from "../record/sugar";
import MemberRecordUncomfortable from "../record/uncomfortable";
import MemberRecordHealth from "../record/health";
import { setPageSetting } from "../../../service/common";
import { option_category, option_category_obj } from "../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";

import img_crown from "../../../images/crown.png";

export default function MemberWork({ moduleType = "member" }) {
  const dispatch = useDispatch();
  const route_navigate = useNavigate();
  const redux_user = useSelector((state) => state.user);
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "功課表" },
  ];
  const [reload, setReload] = useState({ list: false });
  const [apiData, setApiData] = useState(null);
  const [crownData, setCrownData] = useState([]);
  const { isPop, popOption, openPop, closePop, renderDialog } = usePop([
    {
      key: "record",
      title: (props) => option_category_obj.record[props.data.type].label,
      isOpen: false,
    },
  ]);
  // 篩選條件
  const defaultFilter = {
      searchDate: new Date(),
    },
    pagePath = "/work";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const finalRate = useMemo(
    () =>
      apiData
        ? Math.round(
            (apiData?.filter((item) => item.isRecord).length / apiData.length) *
              10000
          ) / 100
        : 0,
    [apiData]
  );

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list) return;

      dispatch(setProgress(true));

      setPageSetting({ params: search, page: pagePath });

      let dayIndex = new Date(search.searchDate).getDay();
      if (dayIndex === 0) dayIndex = 7;

      let params = {
        ...search,
        searchDate: search.searchDate
          ? moment(search.searchDate).format("YYYY-MM-DD")
          : null,
      };

      AxiosMulti([
        WorkAPI.getDoRateListByMemberid({
          data: {
            memberid: redux_user.userDetail.id,
          },
          options: { signal },
        }),
        WorkAPI.getMyPersonalGoalsDatas({
          data: params,
          options: { signal },
        }),
      ]).then(
        axios.spread((result_crown, result_work) => {
          let { data: result_crown_data } = result_crown;
          if (result_crown.Response === 1) {
            setCrownData(result_crown_data);
          }

          let { data: result_work_data, today_record } = result_work;
          if (result_work.Response === 1) {
            let formatData = [];
            option_category.record.forEach((item) => {
              if (
                result_work_data[`type${item.type}`]?.[`day${dayIndex}`] === 1
              ) {
                formatData.push({
                  ...item,
                  isRecord: today_record[`record_${item.apiKey}`] === 1,
                });
              }
            });
            setApiData(formatData);
          }

          setReload((state) => ({
            ...state,
            list: false,
          }));

          let isError = formatApiResult({
            data: [result_crown, result_work],
            action: (message) => {
              dispatch(
                setToast({
                  severity: "error",
                  summary: message,
                  detail: "",
                })
              );
            },
          });
          if (isError) {
            dispatch(setProgress(false));
            return;
          }

          dispatch(setProgress(false));
        })
      );
    },
    [reload]
  );

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle data={{ title: "功課表" }} />

      {renderSearchWrap({
        isShow: false,
        template: (
          <>
            <div className="col-12 sm:col-6 md:col-3 flex align-items-start flex-column mt-2 md:mt-0">
              <label
                htmlFor="username"
                className="w-4rem white-space-nowrap text-left mb-1"
              >
                日期
              </label>
              <Calendar
                className="w-full"
                name="searchDate"
                value={
                  filterData.searchDate ? new Date(filterData.searchDate) : null
                }
                onChange={(e) => changeFilter(e)}
                readOnlyInput
                showButtonBar
              />
            </div>
            <div
              className={classNames(
                "col-12 sm:col-6 md:col-9 flex align-items-end mt-2 md:mt-0"
              )}
            >
              <Button
                className="p-button-info p-button-sm w-auto ml-auto md:ml-0 px-3"
                type="button"
                icon="pi pi-search"
                label="查詢"
                onClick={() =>
                  setSearch({
                    ...filterData,
                    page: 1,
                  })
                }
              />
            </div>
          </>
        ),
      })}

      {apiData === null && (
        <div className="text-center text-xl text-red-400 border-1 border-400 border-round-md p-3 mt-2">
          查詢中
        </div>
      )}
      {apiData?.length === 0 && (
        <div className="text-center text-xl text-red-400 border-1 border-400 border-round-md p-3 mt-2">
          無資料
        </div>
      )}
      {apiData?.length > 0 && (
        <div className="line-height-4 mt-3">
          {apiData.map((item) => (
            <div
              key={`type_${item.type}`}
              className="flex align-items-center text-xl border-bottom-1 border-400 py-2"
            >
              <div className="w-10rem font-bold">{item.label}</div>
              {item.isRecord && (
                <div className="flex align-items-center w-full">
                  <div className="text-3xl">&#128512;</div>
                  <div className="text-xl text-green-400 ml-2">已填寫</div>
                  <Button
                    className="p-button-success p-button-sm w-auto ml-auto px-3"
                    type="button"
                    label="檢視記錄"
                    onClick={() =>
                      openPop({ type: "record", data: { type: item.value } })
                    }
                  />
                </div>
              )}
              {!item.isRecord && (
                <div className="flex align-items-center w-full">
                  <div className="text-3xl">&#128546;</div>
                  <div className="text-xl text-red-400 ml-2">尚未填寫</div>
                  <Button
                    className="p-button-danger p-button-sm w-auto ml-auto px-3"
                    type="button"
                    label="新增記錄"
                    onClick={() =>
                      openPop({ type: "record", data: { type: item.value } })
                    }
                  />
                </div>
              )}
            </div>
          ))}

          <div className="flex align-items-center text-2xl text-orange-400 font-bold mt-3">
            {`執行率：${finalRate}% `}
            <span className="flex align-items-center text-red-400 ml-2">
              (
              {
                crownData.filter(
                  (item) => item.today_record.doRatesRecords.point === 1
                ).length
              }
              <img className="w-2rem ml-1" src={img_crown} />)
            </span>
          </div>
        </div>
      )}

      {renderDialog({
        className: "w-11",
        closable: isPop.security?.isOpen ? false : true,
        onHide: () => {
          closePop({ type: popOption.type });
          setReload((state) => ({ ...state, list: true }));
        },
        children: (
          <>
            {isPop.record?.isOpen && (
              <div className="px-3">
                {popOption.data.type === "heartbeat" && (
                  <MemberRecordHeartbeat
                    moduleType="memberPop"
                    closePrePop={closePop}
                    prePopOption={popOption}
                    setPreReload={setReload}
                  />
                )}
                {popOption.data.type === "weight" && (
                  <MemberRecordWeight
                    moduleType="memberPop"
                    closePrePop={closePop}
                    prePopOption={popOption}
                    setPreReload={setReload}
                  />
                )}
                {popOption.data.type === "sugar" && (
                  <MemberRecordSugar
                    moduleType="memberPop"
                    closePrePop={closePop}
                    prePopOption={popOption}
                    setPreReload={setReload}
                  />
                )}
                {popOption.data.type === "uncomfortable" && (
                  <MemberRecordUncomfortable
                    moduleType="memberPop"
                    closePrePop={closePop}
                    prePopOption={popOption}
                    setPreReload={setReload}
                  />
                )}
                {popOption.data.type === "health" && (
                  <MemberRecordHealth
                    moduleType="memberPop"
                    closePrePop={closePop}
                    prePopOption={popOption}
                    setPreReload={setReload}
                  />
                )}
              </div>
            )}
          </>
        ),
      })}
    </>
  );
}
